module.exports = __webpack_public_path__ + "static/media/msg.9c6afaa5.svg";